import { render, staticRenderFns } from "./NewRoom.vue?vue&type=template&id=0f705056&scoped=true&"
import script from "./NewRoom.vue?vue&type=script&lang=js&"
export * from "./NewRoom.vue?vue&type=script&lang=js&"
import style0 from "./NewRoom.vue?vue&type=style&index=0&id=0f705056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f705056",
  null
  
)

export default component.exports